const state = {
  total: 0,
  page: 0,
  pageIndex: 1,
  limit: 10,
  list: [],
  offset: 0,
  current: null
}

const mutations = {
  SET_NURSE_LIST(state, { payload }) {
    state.total = payload.total
    state.list = payload.list
  },
  CREATE_NURSE(state, { payload }) {
    state.list.unshift(payload.nurse)
    if (state.list.length > state.limit) {
      state.list.pop()
    }
  },
  SET_NURSE(state, { payload }) {
    state.current = payload
  }
}

const actions = {
  setNurseList({ commit }, payload) {
    // do something async
    commit('SET_NURSE_LIST', {
      payload: payload
    })
  },
  createNurse({ commit }, payload) {
    // do something async
    commit('CREATE_NURSE', {
      payload: payload
    })
  },
  setNurse({ commit }, payload) {
    // do something async
    commit('SET_NURSE', {
      payload: payload
    })
  }
}

export default {
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/Nurse.js